import styles from "./Cursor.module.css";
export const Cursor = () => {
  return <div className={styles.cursor}></div>;
};
